import { Box } from '@mui/material';

const IndicatorsPage3 = () => {
  return (
    <>
      <Box height={'100%'} width={'100%'} p={'20px'}>
        <iframe
          title="Portafolio Indicadores Limpieza de col v2"
          width="100%"
          height="100%"
          src="https://app.powerbi.com/view?r=eyJrIjoiOTU2NzU0MzYtZjc0ZC00ZmRmLTg4OGYtM2U2YzYxMGMyZDEwIiwidCI6IjRjMDdiMDA3LTU3N2UtNDY1Ny1hNjUyLWYyNTBkNzc4OTBjMyJ9"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </Box>
    </>
  );
};

export default IndicatorsPage3;
